import React from "react";
import { useHistory } from "react-router-dom";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MoreVertical, Eye } from 'lucide-react';

const Severity = {
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low'
};

function DeviceDetailsTableRow({ data, index, deviceId }) {

    const history = useHistory();

    const onDetailsClick = () => history.push('/add-rules/' + data.rulePk);

    const getCircleType = () => {
        if (!data.severity) {
            return '';
        }

        switch (data.severity.toLowerCase()) {
            case Severity.HIGH:
                return "severity-high";
            case Severity.MEDIUM:
                return "severity-medium";
            case Severity.LOW:
                return "severity-low";
            default:
                return '';
        }
    };

    const getValidColor = () => {
        switch (data.valid) {
            case 1:
                return "valid-pass";
            case 0:
                return "valid-fail";
            case -1:
                return "valid-unknown";
            default:
                return '';
        }
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const onViewDetails = () => {
        handleMenuClose();
        onDetailsClick();
    };

    return (
        <tr key={index}>
            <td>{data.rule}</td>
            <td>{data.details}</td>
            <td>{data.expectedOutput}</td>
            <td>{data.user}</td>
            <td>
                <span className={`oct_severity-badge-v2 ${getCircleType()}`}>
                    {data.severity?.toUpperCase()}
                </span>
            </td>
            <td>
                <span className={`oct_valid-badge-v2 ${getValidColor()}`}>
                    {data.valid === 1 ? 'PASS' : data.valid === -1 ? 'UNKNOWN' : 'FAIL'}
                </span>
            </td>
            <td>{data.group}</td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleMenuClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleMenuClose}
                    className="oct_menu-v2"
                >
                    <MenuItem onClick={onViewDetails} className="oct_menu-item-v2">
                        <Eye className="oct_icon" /> View details
                    </MenuItem>
                </Menu>
            </td>
        </tr>
    );
}

export default DeviceDetailsTableRow;
